import Modal from "src/components/common/Modal";
import { useLocation, useNavigate, useSearchParams, useSubmit } from "react-router-dom";
import { useState } from "react";

export default function ExportForm({columns}: {columns: {key: string, label: string}[]}) {
    const navigate = useNavigate();
    const location = useLocation();
    const submit = useSubmit();
    const [searchParams] = useSearchParams();
    const [draft, setDraft] = useState({
        start: "",
        end: "",
        columns: columns.map(c => c.key)
    });
    const toggleColumn = (key: string) => {
        setDraft(prev => ({
            ...prev,
            columns: prev.columns.includes(key)
                ? prev.columns.filter(c => c !== key)
                : [...prev.columns, key],
        }));
    };
    return (
        <Modal
            closeIt = {() =>
                navigate({ pathname: "..", search: location.search }, { replace: true })
            }
            title = "Export"
            width = {600}
            maxWidth = "100%"
        >
            <div className = "m-3">
                <span className = "me-3 fw-bold">Columns</span>
                <div className = "mt-2">
                    {columns.map(col => (
                        <label key = {col.key} className = "me-4">
                            <input
                                type = "checkbox"
                                className = "me-1"
                                checked = {draft.columns.includes(col.key)}
                                onChange = {() => toggleColumn(col.key)}
                            />
                            {col.label}
                        </label>
                    ))}
                </div>
            </div>
            <div className = "mt-5 mb-3">
                <button
                    children = "Select All"
                    type = "button"
                    className = "btn btn-primary"
                    onClick = {() =>setDraft({...draft, columns: columns.map(c => c.key)})}
                />
                <button
                    children = "Deselect All"
                    type = "button"
                    className = "btn btn-secondary ms-3"
                    onClick = {() => setDraft({...draft, columns: []})}
                />
                <button
                    children = "Export"
                    className = "btn btn-success ms-3"
                    onClick = {async() => {
                        const formData = new FormData();
                        formData.append("columns", JSON.stringify(draft.columns));
                        submit(formData, {
                            method: "post",
                            action: "Execute?" + searchParams.toString()
                        });
                    }}
                />
            </div>
        </Modal>
    );
}
